import { Link, Table, Tbody, Td, Text, Thead, Tr } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaMarkdown } from "@nens/ranalib";
import { RanaExtraInfo } from "@nens/ranalib";

export const MarkdownExplanation = () => {
  const intl = useIntl();
  const MARKDOWN_EXPLANATIONS = [
    intl.formatMessage({
      id: "markdown_explain.bold_cursive",
      defaultMessage: "This text is ***really important***",
    }),
    intl.formatMessage({
      id: "markdown_explain.bold",
      defaultMessage: "This text is **really important**",
    }),
    intl.formatMessage({
      id: "markdown_explain.cursive",
      defaultMessage: "This text is _really important_",
    }),
    intl.formatMessage({
      id: "markdown_explain.list",
      defaultMessage: "- first item \n- second item",
    }),
  ];

  return (
    <RanaExtraInfo
      type="modal"
      topBar={
        <FormattedMessage
          id="markdown_explain.header_markdown_explain"
          defaultMessage="Markdown explanation"
        />
      }
    >
      <Table variant="grid">
        <Thead>
          <Tr>
            <Td>
              <FormattedMessage id="markdown_explain.header_markdown" defaultMessage="Markdown" />
            </Td>
            <Td>
              <FormattedMessage id="markdown_explain.header_output" defaultMessage="Output" />
            </Td>
          </Tr>
        </Thead>
        <Tbody>
          {MARKDOWN_EXPLANATIONS.map((explanation, idx) => (
            <Tr key={idx}>
              <Td whiteSpace="pre-line">{explanation}</Td>
              <Td>
                <RanaMarkdown markdown={explanation} />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      <Text mt={6}>
        <FormattedMessage
          id="markdown_explain.more_info"
          defaultMessage="For more information visit:"
        />
      </Text>
      <Link textDecor="underline" href="https://www.markdownguide.org/basic-syntax/" isExternal>
        https://www.markdownguide.org/basic-syntax/
      </Link>
    </RanaExtraInfo>
  );
};
